"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _ = require("../..");

var _styles = require("../../styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = function styles(theme) {
  var _embed;

  return {
    embed: (_embed = {
      width: '100%',
      height: '100%'
    }, (0, _defineProperty2["default"])(_embed, theme.breakpoints.down('sm'), {
      height: theme.spacing(63)
    }), (0, _defineProperty2["default"])(_embed, theme.breakpoints.down('xs'), {
      height: theme.spacing(81)
    }), _embed)
  };
};

exports.styles = styles;
var useStyles = (0, _styles.makeStyles)(styles);

var ErrorScreen = function ErrorScreen() {
  return /*#__PURE__*/_react["default"].createElement(_.Grid, {
    container: true,
    item: true,
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    xs: 12,
    md: 7
  }, /*#__PURE__*/_react["default"].createElement(_.Alert, {
    variant: "filled",
    severity: "error"
  }, "We're sorry something went wrong. Please request a new signup token or link."));
};

var BorrowerChoosePassword = function BorrowerChoosePassword(_ref) {
  var claimToken = _ref.claimToken,
      onSuccess = _ref.onSuccess,
      links = _ref.links;
  var classes = useStyles();
  var loginAnonEl = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      hasError = _useState2[0],
      setHasError = _useState2[1];

  var raiseError = function raiseError() {
    return setHasError(true);
  };

  var clearError = function clearError() {
    return setHasError(false);
  };

  (0, _react.useEffect)(function () {
    var handler = function handler(event) {
      var _event$data;

      switch (event === null || event === void 0 ? void 0 : (_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.type) {
        case 'success':
          onSuccess();
          break;

        case 'error':
          raiseError();
          break;

        default:
          break;
      }
    };

    window.addEventListener('message', handler); // clean up

    return function () {
      return window.removeEventListener('message', handler);
    };
  }, []);
  return hasError ? /*#__PURE__*/_react["default"].createElement(ErrorScreen, null) : /*#__PURE__*/_react["default"].createElement(_.Grid, {
    container: true,
    item: true,
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    xs: 12,
    md: 7
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    id: "login-anon-embed",
    title: "Embedded EarnUp Secure Login Portal",
    name: "login-anon-embed",
    ref: loginAnonEl,
    src: "".concat(links.loginAnonEmbedURL, "?rt=").concat(claimToken, "&origin=").concat(window.location.origin),
    className: classes.embed,
    frameBorder: "0",
    onLoad: clearError,
    onAbort: raiseError,
    onError: raiseError
  }));
};

BorrowerChoosePassword.propTypes = {
  claimToken: _propTypes["default"].string.isRequired,
  onSuccess: _propTypes["default"].func.isRequired
};
var _default = BorrowerChoosePassword;
exports["default"] = _default;